module.exports = __webpack_public_path__ + "static/img/avatar_3.ffef448.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_3.png
// module id = 1594
// module chunks = 61